import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import Tag from "@src/components/core-tag"
const StyledTagList = styled.div`
  display: flex;
  ${props =>
    props.header
      ? css`
          gap: 6px;
          @media only screen and (${props => props.theme.screen.medium.min}) {
            gap: 10px;
          }
        `
      : css`
          gap: 2px 4px;
        `}
`
const TagList = ({ className, tags, header }) => {
  return tags && tags.length ? (
    <StyledTagList className={className} header={header}>
      {tags.map((tag, index) => (
        <Tag key={index} header={header} {...tag} />
      ))}
    </StyledTagList>
  ) : null
}
TagList.propTypes = {
  className: PropTypes.string,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      group: PropTypes.string,
      value: PropTypes.string,
      link: PropTypes.string,
    })
  ),
  header: PropTypes.bool,
}
export default TagList
